import React from 'react';
import { Clock } from 'lucide-react';
import { tomorrowLabel } from '../../utils/dtdCutoff';

// Pop-up shown before a DTD CableTV recharge is paid after 8 PM — see utils/dtdCutoff.js.
// Nothing is charged until the payer presses "I understand". `audience` picks the wording:
// 'customer' (portal / pay link) or 'staff' (CRM Renew panel, agent app). `at` is when the
// payment is being collected (staff can back-date it), default now.
export default function DtdAfter8pmNotice({ audience = 'customer', at, onConfirm, onCancel }) {
  const date = tomorrowLabel(at || new Date());
  const isStaff = audience === 'staff';
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 10000, padding: 16,
    }} onClick={onCancel}>
      <div role="dialog" aria-modal="true" aria-labelledby="dtd-8pm-title" style={{
        background: '#fff', borderRadius: 14, width: '100%', maxWidth: 380,
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)', padding: '22px 20px',
      }} onClick={(e) => e.stopPropagation()}>
        <div style={{
          width: 46, height: 46, borderRadius: 12, background: '#fef3c7', display: 'flex',
          alignItems: 'center', justifyContent: 'center', marginBottom: 14,
        }}>
          <Clock size={22} color="#b45309" />
        </div>
        <div id="dtd-8pm-title" style={{ fontSize: '1.02rem', fontWeight: 800, color: '#1e293b', marginBottom: 8 }}>
          {isStaff ? 'Recharge after 8 PM' : 'You are recharging after 8 PM'}
        </div>
        {isStaff ? (
          <div style={{ fontSize: '.87rem', color: '#475569', lineHeight: 1.55 }}>
            It is past 8 PM, so this DTD CableTV recharge will be counted from <b>tomorrow, {date}</b>, not today.
            The full validity starts tomorrow, and the GTPL Saathi order will be placed automatically tomorrow after 9:30 AM.
            <div style={{ marginTop: 8 }}>Please tell the customer their channels will start tomorrow morning.</div>
          </div>
        ) : (
          <div style={{ fontSize: '.87rem', color: '#475569', lineHeight: 1.55 }}>
            Dear customer, it is past 8 PM, so this recharge will be counted from <b>tomorrow, {date}</b>, not today.
            Your channels will be switched on tomorrow morning after 9:30 AM.
            <div style={{ marginTop: 8 }}>Your full validity starts from tomorrow, so you do not lose any days.</div>
          </div>
        )}
        <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
          <button type="button" className="btn btn-secondary" onClick={onCancel} style={{ flex: 1, justifyContent: 'center' }}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={onConfirm} style={{ flex: 2, justifyContent: 'center' }} autoFocus>
            I understand, continue
          </button>
        </div>
      </div>
    </div>
  );
}
